import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { ConstantsService } from '../service/constants.service';

@Injectable({
	providedIn: 'root'
})
export class HistoryService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

	loadDataHistory(): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/eboihistory`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	testService(queueId,excelName): Promise<any>{
		const reportObject = {
			queueId : queueId,
			excelName : excelName
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/eboihistory/getExcelReports`, reportObject, { headers: this.constantsService.httpOptions, responseType: 'blob' })
		  .pipe(
			timeout(260000),
			catchError(this.handleError)).toPromise();
	  }
	loadDataHistoryLogs(queueID): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/eboihistory/getLogs/${queueID}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	deleteHistory(queueId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/eboihistory/delete/${queueId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}

}
